import { render, staticRenderFns } from "./FinalPaymentModalTemplate.vue?vue&type=template&id=4f5b66fa&scoped=true&"
import script from "./FinalPaymentModalTemplate.vue?vue&type=script&lang=js&"
export * from "./FinalPaymentModalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FinalPaymentModalTemplate.vue?vue&type=style&index=0&id=4f5b66fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b66fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5b66fa')) {
      api.createRecord('4f5b66fa', component.options)
    } else {
      api.reload('4f5b66fa', component.options)
    }
    module.hot.accept("./FinalPaymentModalTemplate.vue?vue&type=template&id=4f5b66fa&scoped=true&", function () {
      api.rerender('4f5b66fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/FinalPaymentModalTemplate.vue"
export default component.exports